import StringTokenizer from "./StringTokenizer";
import DiacriticsUtil from "./DiacriticsUtil"

// TODO: convert to class
export default function StringIndex( tokenizer )
{
    this.index = {};
    this.tokenizer = tokenizer || new StringTokenizer();
}

StringIndex.prototype.getFirstCharWithoutDiacritics = function( token )
{
    var firstChar = token.charAt( 0 );
    //noinspection JSUnresolvedVariable
    var nonDiacriticFirstChar = window.DiacriticsUtilConstants.LIGATURES_REVERSE_MAP[ firstChar ];
    if( nonDiacriticFirstChar )
        return nonDiacriticFirstChar.charAt( 0 );
    //noinspection JSUnresolvedVariable
    nonDiacriticFirstChar = window.DiacriticsUtilConstants.DIACRITICS_REVERSE_MAP[ firstChar ];
    if( nonDiacriticFirstChar )
        return nonDiacriticFirstChar;
    return firstChar;
};

StringIndex.prototype._getTokenObject = function(token, create)
{
    var firstChar = this.getFirstCharWithoutDiacritics( token );
    var firstCharObject = this.index[firstChar];
    if( !firstCharObject )
    {
        firstCharObject = {};
        this.index[firstChar] = firstCharObject;
    }
    var tokenObject = firstCharObject[token];
    if( !tokenObject && create )
    {
        tokenObject = {};
        firstCharObject[token] = tokenObject;
    }

    return tokenObject;
};

StringIndex.prototype.addToken = function(token, objId)
{
    this._getTokenObject(token, true)[objId] = objId;
};

StringIndex.prototype.removeToken = function(token, objId)
{
    var tokenObject = this._getTokenObject(token, false);
    if (tokenObject)
        delete tokenObject[objId];
};

StringIndex.prototype.getTokenizer = function()
{
    return this.tokenizer;
};

StringIndex.prototype.addTokens = function( tokens, objId )
{
    for( var i = 0; i < tokens.length; i++ )
        this.addToken( tokens[i], objId );
};

StringIndex.prototype.removeTokens = function( tokens, objId )
{
    for( var i = 0; i < tokens.length; i++ )
        this.removeToken( tokens[i], objId );
};


StringIndex.prototype.add = function( str, objId )
{
    var tokens = this.tokenizer.getTokens( str.toLowerCase() );
    this.addTokens( tokens, objId );
};

StringIndex.prototype.remove = function( str, objId )
{
    var tokens = this.tokenizer.getTokens( str.toLowerCase() );
    this.removeTokens( tokens, objId );
};

StringIndex.prototype.search = function( tokens )
{
    var result = {};

    if( tokens.length == 0 )
        return result;

    this.addIdsForToken( tokens[0], result );

    for( var i = 1; i < tokens.length; i++ )
        result = this.intersectWithSearchResultsForToken( tokens[i], result );

    return result;
};

StringIndex.prototype.createTokenPattern = function( token )
{
    //noinspection JSUnresolvedVariable, JSUnresolvedFunction
    return new RegExp( "^" + DiacriticsUtil.makeMatchingRegexp( token ) );
};

StringIndex.prototype.addIdsForToken = function( token, result )
{
    var firstChar = this.getFirstCharWithoutDiacritics( token );
    var firstCharObject = this.index[firstChar];
    if( firstCharObject )
    {
        var regexp = this.createTokenPattern( token  );
        for( var str in firstCharObject )
        {
            //noinspection JSUnfilteredForInLoop
            if( regexp.test( str ) )
            {
                //noinspection JSUnfilteredForInLoop
                var strObj = firstCharObject[str];
                for( var id in strObj )
                {
                    //noinspection JSUnfilteredForInLoop
                    result[id] = id;
                }
            }
        }
    }
};

StringIndex.prototype.intersectWithSearchResultsForToken = function( token, result )
{
    var intersection = {};
    var firstChar = this.getFirstCharWithoutDiacritics( token );
    var firstCharObject = this.index[firstChar];
    if( firstCharObject )
    {
        var regexp = this.createTokenPattern( token  );
        for( var str in firstCharObject )
        {
            //noinspection JSUnfilteredForInLoop
            if( regexp.test( str ) )
            {
                //noinspection JSUnfilteredForInLoop
                var strObj = firstCharObject[str];
                for( var id in strObj )
                {
                    //noinspection JSUnfilteredForInLoop
                    if( result[id] )
                    //noinspection JSUnfilteredForInLoop
                        intersection[id] = id;
                }
            }
        }
    }
    return intersection;
};


// WEBPACK FOOTER //
// ./web/js/util/StringIndex.js